import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const APiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='143'
        height='136'
        viewBox='0 0 143 136'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M75.4103 4.54272L141.021 123.386C143.965 128.718 140.108 135.252 134.017 135.252L8.88338 135.252C2.93393 135.252 -0.933899 128.989 1.73042 123.67L61.2537 4.82662C64.1379 -0.931954 72.2975 -1.09557 75.4103 4.54272Z' />
      </svg>
    </div>
  );
});

APiece.displayName = 'APiece';

export default motion.create(APiece);
